import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=084da23a&"
import script from "./InfoContainer.vue?vue&type=script&lang=js&"
export * from "./InfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports